import { useMutation as e } from "@maat/store-hooks";
import { referralApi as t } from "@maat/api-main";
//#region src/partners/useReferralResolveMutation.ts
var n = () => e({ mutationFn: (e) => t.resolve(e) });
//#endregion
export { n as useReferralResolveMutation };
